import { BaseModel } from '@model/BaseModel';
import * as Yup from 'yup';
import { Model } from './Model';

export class ItemSpecification extends BaseModel {
    public quantity!: number;
    public name!: string;
    public text!: string;
    public number!: string;
    public item_id!: number;
    public size_id!: number;
    public size_code!: string;
}

export const ItemSpecificationModel = Model<ItemSpecification>('ItemSpecification', {
    endpoint: 'apparel-item-specifications',
})`
    id:Int;
    quantity:Int;
    name:String;
    text:String;
    number:String;
    item_id:Int;
    size_id:Int;
    size_code:String;
    created_at:DateTime;
    updated_at:DateTime;
`;

const numberErrorMessage = 'Please enter a number up to 3 digits';

export const ItemSpecificationValidation = Yup.object({
    name: Yup.string().nullable(),
    size_id: Yup.number().nullable(),
    quantity: Yup.number()
        .required('Enter a quantity')
        .typeError('Qty must be numeric')
        .positive('Qty must be positive number')
        .min(1, 'Please enter a qty greater then 1')
        .max(10000, 'We are not supporting ordering more then 10,000 items')
        .nullable(),

    number: Yup.string()
        .matches(/^(\s*|\d+)$/, 'Please enter a valid number')
        .max(3, numberErrorMessage)
        .nullable(),
});
